import {gql} from "apollo-angular";

/**
 * Shared Merchant fragment.
 */
const FRAGMENT_EXTENDED_COMPANY = gql`
  fragment ExtendedCompanyFields on Company {
    id
    name
    logo
    email
    phone,
    createdAt,
    updatedAt,
    userCompanies {
      id
      userId
      companyId
      createdAt
      updatedAt
      user {
        id
        email
        firstName
        lastName
        phone
        createdAt
        updatedAt
      }
    }
  }
`;
const FRAGMENT_COMPANY = gql`
  fragment CompanyFields on Company {
    id
    name
    logo
    email
    phone,
    createdAt,
    updatedAt,
  }
`;


const GET_COMPANIES = gql`
  query getCompanies {
    companies {
      ...CompanyFields
    }
  }
  ${FRAGMENT_COMPANY}
`;

const GET_EXTENDED_COMPANIES = gql`
  query getExtendedCompanies {
    companies {
      ...ExtendedCompanyFields
    }
  }
  ${FRAGMENT_EXTENDED_COMPANY}
`;

const GET_COMPANY = gql`
  query getCompany($id: UUID!) {
    companies(where: { id: { eq: $id }}) {
      ...ExtendedCompanyFields
    }
  }
  ${FRAGMENT_EXTENDED_COMPANY}
`;

const ADD_COMPANY = gql`
  mutation addCompany($company: CompanyMutationInput!, $logInfo: EntityLogInfoInput!) {
    addCompany(company: $company, logInfo: $logInfo) {
      ...CompanyFields
    }
  }
  ${FRAGMENT_COMPANY}
`;

const UPDATE_COMPANY = gql`
  mutation updateCompany($company: CompanyMutationInput!, $logInfo: EntityLogInfoInput!) {
    updateCompany(company: $company, logInfo: $logInfo) {
      ...CompanyFields
    }
  }
  ${FRAGMENT_COMPANY}
`;
const CREATE_OR_UPDATE_CLIENT_CREDENTIAL = gql`
  mutation createOrUpdateClientCredential($clientCredential: ClientCredentialMutationInput!, $logInfo: EntityLogInfoInput!) {
    addClientCredential(clientCredential: $clientCredential, logInfo: $logInfo) {
      id
      name
      _clientSecret
      providerId
      productId
      merchantId
      createdAt
      updatedAt
    }
  }
`;

const DELETE_COMPANY = gql`
  mutation deleteCompany($id: UUID!, $logInfo: EntityLogInfoInput!) {
    deleteCompany(id: $id, logInfo: $logInfo)
  }
`;
export {GET_COMPANIES, GET_COMPANY, GET_EXTENDED_COMPANIES, ADD_COMPANY, DELETE_COMPANY,UPDATE_COMPANY,CREATE_OR_UPDATE_CLIENT_CREDENTIAL};
